import { Component, OnInit, Input } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {NavController} from "@ionic/angular";
import {Plugins} from '@capacitor/core';

const { Network } = Plugins;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  status: boolean = true;

  constructor( private authService: AuthService, private navCtrl: NavController) { }
  @Input() title: string;
  ngOnInit() {}
  logout() {
    var sta = Network.getStatus();
    sta.then((val) => {
      this.status = val.connected;
      if(this.status){
        this.authService.logout().subscribe((data) => {
          this.navCtrl.navigateRoot('/login');
        }, (error) => console.log(error));
      }else{
        this.navCtrl.navigateRoot('/login');
      }
    });

  }
}
